import React, { useRef } from 'react';
import { Box } from '@chakra-ui/react';
import IeDescriptionV5 from '@in-person/Sections/IeDescriptionV5';
import ResearchShowsV5 from '@in-person/Sections/ResearchShowsV5';
import TrueMiracle from './TrueMiracle';
import IeoBenefitsV5 from './IeoBenefitsV5';
import ProgramContinuedSupport from './ProgramContinuedSupport';
import OnlineInPersonTabCommonHeader from './OnlineInPersonTab/OnlineInpersonTabCommon';
import OnlineTab from './OnlineInPersonTab/OnlineTab';
import ProgramCardSection from '@in-person/Sections/ProgramCardSection';
import EnrollSection from '@in-person/Sections/EnrollSection';
import FaqContents from '@in-person/Sections/FaqContents';
import ProgramSupportV3 from '@in-person/Sections/ProgramSupportV3';
import ProgramTestimonial from './ProgramTestimonial';
import RegisterStickyButton from '@in-person/Components/RegisterStickyButton';
import CompareTabs from '@in-person/Sections/CompareTabs';
import SadhguruLiveSection from '@in-person/Sections/SadhguruLiveSection';
import TopBanner from '@in-person/Sections/TopBanner';
import AdBanner from '@in-person/Sections/AdBanner';

const RenderSections = ({
  section,
  region,
  lang,
  pType,
  csrData,
  supportData,
  couponData,
  pageData,
  pageName,
  mode,
  context,
  setContext,
  cityId,
}) => {
  const sectionId = section?.sectionId;
  const scrollRef = useRef(null);
  const scholarshipsRef = useRef(null);

  const allSections = pageData?.body?.[0]?.value || [];
  const onlineSection = allSections.find(s => s.sectionId === 'ieo-online-tab');
  // const inPersonSection = allSections.find(
  //   s => s.sectionId === 'ieo-inperson-tab'
  // );
  // const inPersinProgramFee = allSections.find(
  //   s => s.sectionId === 'ieo-inperson-program-fees'
  // );
  const onlineProgramFee = allSections.find(
    s => s.sectionId === 'ieo-online-program-fee'
  );
  const ieoEnrollSection = allSections.find(
    s => s.sectionId === 'ieo-enroll-section'
  );

  if (sectionId === 'top-banner') {
    return (
      <TopBanner
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        pageData={pageData}
        pageName={pageName}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'register-sticky-button') {
    return (
      <RegisterStickyButton
        lang={lang}
        region={region}
        sectionContent={section.sectionContent}
        pageData={pageData}
        pageName={pageName}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'Online-Inperson-Table') {
    return (
      <CompareTabs
        lang={lang}
        region={region}
        sectionContent={section.sectionContent}
        pageData={pageData}
        pageName={pageName}
        prgData={csrData}
        isOpen={true}
      />
    );
  } else if (sectionId === 'sadhguru-live') {
    return (
      <>
        {' '}
        <SadhguruLiveSection
          lang={lang}
          region={region}
          pageData={pageData}
          pageName={pageName}
          sectionContent={section?.sectionContent}
          prgData={csrData}
        />
      </>
    );
    // } else if (
    //   sectionId === 'ieo-enroll-section' ||
    //   sectionId === 'ieo-register-page-section' ||
    //   sectionId === 'ieo-enroll-section-v3'
    // ) {
    //   return (
    //     <EnrollSection
    //       sectionContent={section.sectionContent}
    //       region={region}
    //       lang={lang}
    //       prgData={csrData}
    //       couponData={couponData}
    //       pageData={pageData}
    //       context={context}
    //       pageName={pageName}
    //       setContext={setContext}
    //       scrollRef={scrollRef}
    //     />
    //   );
  } else if (sectionId === 'ie-description-v5') {
    // TODO this is the section which can be reused for intro section
    return (
      <IeDescriptionV5
        lang={lang}
        region={region}
        pageData={pageData}
        pageName={pageName}
        sectionContent={section?.sectionContent}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'research-shows-v5') {
    // TODO : This is rendering the second research intro
    return (
      <ResearchShowsV5
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'ieo-shambhavi-benefits') {
    return <TrueMiracle sectionContent={section.sectionContent} />;
  } else if (sectionId === 'ieo-benefits-v5') {
    return (
      <IeoBenefitsV5
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'program-testimonial') {
    return (
      <ProgramTestimonial
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        pageData={pageData}
        pageName={pageName}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'ieo-program-support-v3') {
    return (
      <ProgramSupportV3
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        pageData={pageData}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'Ad-banner') {
    return (
      <AdBanner
        sectionContent={section.sectionContent[0]}
        region={region}
        lang={lang}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'ieo-benefits-v5') {
    return (
      <ProgramContinuedSupport
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        pageData={pageData}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'ieo-online-inperson-tab') {
    return (
      <Box bg="#F1EBDF" overflow={'hidden'}>
        <OnlineInPersonTabCommonHeader
          section={section.sectionContent}
          region={region}
          lang={lang}
        />
      </Box>
    );
  } else if (section.sectionId === 'ieo-online-tab') {
    return (
      <Box
        pt={{ base: 5, md: 9 }}
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        bg="#F1EBDF"
        overflow={'hidden'}
      >
        {/* <BaseTabComponent
          // inPersonContent={inPersonSection?.sectionContent}
          onlineContent={onlineSection?.sectionContent}
          sectionId={sectionId}
          pageData={pageData}
          pageName={pageName}
          prgData={csrData}
          scholarshipsRef={scholarshipsRef}
          couponData={couponData}
          context={context}
          setContext={setContext}
          scrollRef={scrollRef}
          // inPersonProgramFeeContent={inPersinProgramFee?.sectionContent}
          onlineProgramFeeContent={onlineProgramFee?.sectionContent}
          ieoEnrollSectionContent={ieoEnrollSection?.sectionContent}
        /> */}
        <OnlineTab
          sectionId={sectionId}
          section={onlineSection?.sectionContent}
          pageData={pageData}
          pageName={pageName}
          prgData={csrData}
          scholarshipsRef={scholarshipsRef}
          couponData={couponData}
          context={context}
          setContext={setContext}
          scrollRef={scrollRef}
          programFeeContent={onlineProgramFee?.sectionContent}
          ieoEnrollSectionContent={ieoEnrollSection?.sectionContent}
          region={region}
          lang={lang}
        />
      </Box>
    );
  } else if (sectionId === 'ieo-program-section') {
    return (
      <ProgramCardSection
        sectionContent={section.sectionContent}
        region={region}
        lang={lang}
        scholarshipsRef={scholarshipsRef}
        prgData={csrData}
      />
    );
  } else if (sectionId === 'ieo-faq-section') {
    return (
      <FaqContents
        region={region}
        lang={lang}
        sectionContent={section.sectionContent}
        prgData={csrData}
      />
    );
  }
};

export default RenderSections;
